import BaseApiService from './BaseApiService'

export interface Connector {
  connectorId: string
  name: string
  templateVersionId: string
  fieldMapJson: string
  outputFormat: string
  responseMode: string
  callbackUrl: string | null
  isActive: boolean
  lastTriggeredAt: string | null
  createdAt: string
  receiveUrl: string
  secret?: string
  connectorType?: string
  oAuthConnectionId?: string | null
}

export interface CreateConnectorRequest {
  name: string
  templateVersionId: string
  fieldMapJson?: string
  outputFormat?: string
  responseMode?: string
  callbackUrl?: string | null
  connectorType?: string
  oAuthConnectionId?: string | null
}

export interface UpdateConnectorRequest extends CreateConnectorRequest {
  isActive?: boolean
}

class ConnectorsApiService extends BaseApiService {
  list(): Promise<Connector[]> {
    return this.post('/v1/connectors/list')
  }

  create(req: CreateConnectorRequest): Promise<Connector> {
    return this.post('/v1/connectors/create', req)
  }

  update(connectorId: string, req: UpdateConnectorRequest): Promise<void> {
    return this.post(`/v1/connectors/${connectorId}/update`, req)
  }

  rotateSecret(connectorId: string): Promise<{ secret: string }> {
    return this.post(`/v1/connectors/${connectorId}/rotate-secret`)
  }

  delete(connectorId: string): Promise<void> {
    return this.post(`/v1/connectors/${connectorId}/delete`)
  }
}

export const connectorsApiService = new ConnectorsApiService()
